<template>
  <v-dialog
    :model-value="showDialog"
    no-click-animation
    max-width="720"
    scrim="white"
    class="overlay-backdrop-filter"
    persistent
  >
    <v-card class="pt-4 pb-8 px-3 upgrade-card" rounded="lg">
      <div class="d-flex justify-end">
        <v-btn
          class="modal-close-btn"
          append-icon="fa-solid fa-xmark"
          flat
          rounded="pill"
          variant="text"
          size="small"
          @click="$emit('closeUpgradeNotice')"
        >
          {{ $vuetify.display.xs ? "" : "Aizvērt" }}
        </v-btn>
      </div>

      <div class="scrollable-content">
        <div class="text-center mt-4">
          <div class="text-h4 font-weight-bold mb-4">Izmanto Somas<br />pilnās priekšrocības</div>
        </div>

        <div class="text-center my-4">
          <div class="mb-4">
            Papildini savu Somu un izbaudi visu mācību
            <br />
            saturu bez ierobežojumiem.
          </div>
        </div>

        <div class="card-actions my-4 d-flex flex-column flex-sm-row justify-center gap-10">
          <v-btn flat class="v-btn-quiz" color="yellowActive" rounded="pill" @click="redirectToUpgrade"> Abonēt </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
export default {
  props: {
    showDialog: {
      required: true,
      type: Boolean,
    },
  },

  emits: ["closeUpgradeNotice"],

  setup() {
    const config = useRuntimeConfig()

    return { config }
  },

  methods: {
    redirectToUpgrade() {
      window.location.href = `${this.config.public.oldFrontendRoot}upgrade`
    },
  },
}
</script>

<style lang="sass" scoped>
.overlay-backdrop-filter
  backdrop-filter: blur(7px)
.modal-close-btn
  text-transform: none
  font-size: 15px
  font-weight: 700

.scrollable-content
  height: 100%
  overflow-y: auto
</style>
